import ReactGA from "react-ga4";

// Initialize Google Analytics
ReactGA.initialize("G-M6X42RD952");

// Track page views
const trackPageView = (path, pageTitle) => {
    ReactGA.send({ hitType: "pageview", page: path, title: pageTitle });
};

// Track events
const trackEvent = (event, params) => {
    ReactGA.event(event, params);
};

// Export the functions to use in your components
export { trackPageView, trackEvent };
